import { render, staticRenderFns } from "./SidePanelItemBlock.vue?vue&type=template&id=317bdbf2&scoped=true"
import script from "./SidePanelItemBlock.vue?vue&type=script&lang=ts"
export * from "./SidePanelItemBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidePanelItemBlock.vue?vue&type=style&index=0&id=317bdbf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317bdbf2",
  null
  
)

export default component.exports